import React from 'react';
import About from '../components/sections/About';
import styled from 'styled-components';

const AboutPage = () => {
    return (
        <PageContainer>
            <About />
        </PageContainer>
    );
};

const PageContainer = styled.div`
  padding-top: 80px; // To account for fixed header
`;

export default AboutPage;
